export const chuyenHang = {
  sections: {
    list: { title: 'Stock transfer' },
    detail: { title: 'Transfer voucher detail' },
  },
  titles: { add: 'Create transfer voucher' },
  columns: {
    code: 'Voucher code',
    summary: 'Summary',
    status: 'Status',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    branchFrom: 'From branch',
    branchTo: 'To branch',
    createdAt: 'Created at',
    transferValue: 'Transfer value',
    transferDate: 'Transfer date',
    receivedDate: 'Received date',
    totalQty: 'Total qty',
    totalReceivedQty: 'Received qty',
    receivedValue: 'Received value',
    receiveNote: 'Receive note',
    phieuKho: 'Warehouse voucher',
    maPhieuXuatKho: 'Stock-out voucher',
    maPhieuNhapKho: 'Stock-in voucher',
  },
  filter: {
    searchPlaceholder: 'Search by voucher code...',
    title: 'Filter',
    trangThai: 'Status',
    chiNhanhDi: 'From branch',
    chiNhanhDen: 'To branch',
    tuNgay: 'From date',
    denNgay: 'To date',
    fromDate: 'From date',
    toDate: 'To date',
    dateRangePlaceholder: 'Select date range',
    all: 'All',
    reset: 'Reset',
    sortDir: 'Order',
    asc: 'Ascending',
    desc: 'Descending',
    maHangHoa: 'Product code',
    tenHangHoa: 'Product name',
  },
  placeholders: {
    toolbarSearch: 'By voucher code',
  },
  filters: {
    hintSection: 'Hint',
    hintBody: 'Use search to filter quickly.',
  },
  form: {
    code: 'Voucher code',
    codeAuto: 'Leave blank to auto-generate',
    branchFrom: 'From branch',
    branchTo: 'To branch',
    note: 'Note',
    lines: 'Transfer lines',
    addLine: 'Add empty line',
    product: 'Product',
    productSearch: 'Search code / name',
    qty: 'Transfer qty',
    qtyReceived: 'Received qty',
    unitPrice: 'Transfer price',
    donGiaMua: 'Transfer price',
    giaChuyen: 'Transfer price',
    donViTinhMua: 'UoM',
    dvt: 'UoM',
    maSp: 'SKU',
    tenSp: 'Product name',
    maHang: 'SKU',
    tenHang: 'Product name',
    stt: 'No.',
    tonKho: 'Stock',
    tonKhoNhan: 'Dest. stock',
    hinhThucVc: 'Shipping method',
    cont: 'Container',
    maVanChuyenNcc: 'Supplier shipment no.',
    maVanChuyenAzl: 'AZL shipment no.',
    maYcmh: 'PR no.',
    maBaoGia: 'Quote no.',
    giamGia: 'Discount',
    serialImei: 'Serial/IMEI',
    dateSanPham: 'Product date',
    lineAmount: 'Line amount',
    discount: 'Discount',
    discountPercent: 'Discount (%)',
    lineNote: 'Note',
    createdAt: 'Created at',
    transferDate: 'Transfer date',
    receivedDate: 'Received date',
    totalQty: 'Total qty',
    totalReceivedQty: 'Total received qty',
    receivedValue: 'Received value',
    receiveNote: 'Receive note',
    sectionHeader: 'General info',
    sectionLines: 'Transfer items',
    tongSoMatHang: 'SKU count',
    tongSoLuong: 'Total qty',
    tongTienHang: 'Subtotal',
    lineCount: '{count} line(s)',
    save: 'Save',
  },
  fields: {
    code: 'Voucher code',
    ngayChuyen: 'Transfer date',
    ngayXuatKho: 'Outbound date/time',
    ngayNhapKho: 'Inbound date/time',
    transferValue: 'Transfer value',
  },
  detailTabs: {
    chung: 'Overview',
    generalInfo: 'Info',
    chiTietHang: 'Line items',
    flow: 'Transfer flow',
    lines: 'Transfer lines',
  },
  status: {
    phieuTam: 'Draft',
    choXuat: 'Pending outbound',
    dangChuyen: 'In transit',
    daNhan: 'Received',
    daHuy: 'Cancelled',
    cho: 'Pending',
    daHoanThanh: 'Completed',
  },
  messages: {
    importDescription:
      'Select destination branch, download the template (code / transfer qty / price / discount). One file creates one draft. Import directly or preview to edit first.',
    importSuccess: 'Imported products from Excel.',
    importWillCreate: 'Will create 1 transfer from {count} line(s).',
    importPreviewProgress: 'Preview transfer',
    importPreviewLoading: 'Preparing transfer…',
    importPreviewDone: 'Transfer created from preview.',
    loadError: 'Could not load list.',
    deleteSuccess: 'Transfer voucher deleted.',
    huySuccess: 'Transfer voucher cancelled.',
    confirmHuy:
      'Cancel voucher {name}? Linked outbound and inbound vouchers (if any) will also be cancelled: stock returns to the sending branch and received quantities are deducted from the receiving branch.',
    createSuccess: 'Transfer voucher created.',
    updateSuccess: 'Transfer voucher updated.',
    needLines: 'Add at least one product line.',
    needChiNhanhDen: 'Select destination branch before saving.',
    needMaSp: 'Enter SKU on every line.',
    needTenSp: 'Enter product name on every line.',
    needSoLuong: 'Enter quantity (> 0) on every line.',
    needDonViTinhMua: 'Enter purchase UoM on every line.',
    needMaLo: 'Enter Serial/IMEI for {code}.',
    needHanSuDung: 'Enter product date for {code}.',
    warnOverStock: 'Over stock at source branch: {detail}',
    noData: 'No transfer vouchers.',
    noLines: 'No line items.',
    listSummary: '{count} voucher(s) total',
    confirmDelete: 'Delete voucher {name}?',
    completeSuccess: 'Marked as in transit.',
    batDauChuyenSuccess:
      'Outbound voucher created and completed (stock deducted from sending branch). Transfer moved to In transit.',
    hoanThanhXuatSuccess: 'Outbound completed (source stock deducted). Transfer is now in transit.',
    receiveSuccess: 'Inbound voucher created (destination stock added). Transfer marked as received.',
    confirmComplete: 'Finalize and mark as in transit? Cannot edit after finalizing.',
    confirmBatDauChuyen: 'Confirm transfer {code}?',
    confirmBatDauChuyenWarn: 'Line items cannot be edited after this',
    confirmBatDauChuyenHint1: 'Create and complete the outbound voucher: source stock is deducted immediately.',
    confirmBatDauChuyenHint2: 'Transfer moves to In transit.',
    confirmBatDauChuyenHint3: 'Next: the destination branch confirms receipt to create the inbound voucher and add stock.',
    confirmHoanThanhXuat: 'Complete outbound for transfer {code}?',
    confirmHoanThanhXuatWarn: 'This will deduct stock at the source branch',
    confirmHoanThanhXuatHint1: 'Complete outbound voucher {maPhieu}: deduct stock at the source branch.',
    confirmHoanThanhXuatHint1NoCode: 'Complete the outbound voucher: deduct stock at the source branch.',
    confirmHoanThanhXuatHint2: 'The inbound voucher is created when the destination branch confirms receipt.',
    confirmHoanThanhXuatHint3: 'Transfer moves to In transit.',
    confirmReceive: 'Confirm receipt for transfer {code}?',
    confirmReceiveWarn: 'This will create the inbound voucher and add stock',
    confirmReceiveHint1: 'Complete inbound voucher {maPhieu}: add stock at the destination branch.',
    confirmReceiveHint1NoCode:
      'Create and complete the inbound voucher: add received quantities at the destination branch, at the outbound cost.',
    confirmReceiveHint2: 'Transfer moves to Received. This cannot be undone.',
    needNgayXuatKho: 'Select outbound date/time.',
    needNgayChuyen: 'Select a transfer date before saving.',
    ngayNhanMustAfterXuat: 'Inbound time must be after outbound transfer time.',
  },
  actions: {
    complete: 'Finalize transfer',
    batDauChuyen: 'Confirm transfer',
    huyPhieu: 'Cancel voucher',
    hoanThanhXuat: 'Complete outbound',
    confirmReceive: 'Confirm receipt',
    copy: 'Copy',
    addLine: 'Add empty line',
    importExcel: 'Import Excel',
    downloadTemplate: 'Download template',
    dongY: 'OK',
  },
  aria: {
    columnPicker: 'Choose visible columns',
    xuatKho: 'Outbound transfer voucher',
    nhapKho: 'Inbound transfer voucher',
    empty: 'Not created yet',
    viewPhieuXuat: 'View outbound voucher {maPhieu}',
    viewPhieuNhap: 'View inbound voucher {maPhieu}',
    phieuCho: 'Pending confirmation',
    phieuHoanThanh: 'Completed',
    phieuHuy: 'Cancelled',
  },
  theoDoi: {
    title: 'Transfer tracking',
    tabs: {
      theoDoi: 'Tracking',
      viecCuaToi: 'My tasks',
      doiChieu: 'Reconciliation',
    },
    steps: {
      tao: 'Draft',
      choXuat: 'Pending outbound',
      xuat: 'Outbound',
      dangChuyen: 'In transit',
      nhap: 'Inbound',
      hoanThanh: 'Received',
      daNhan: 'Received',
    },
    searchPlaceholder: 'Search by code or branch...',
    selectPrompt: 'Select a transfer voucher to view details.',
    openDetail: 'Open',
    totalQty: 'Total qty',
    receiveNotePlaceholder: 'Receive note (optional)',
    noPending: 'No vouchers pending confirmation.',
    xuatKho: 'Outbound',
    nhapKho: 'Inbound',
    col: {
      hangHoa: 'Item',
      slChuyen: 'Qty transferred',
      slXuat: 'Qty outbound',
      slNhan: 'Qty received',
      chenhLech: 'Diff',
    },
  },
}
